import moment from 'moment';

export const WEEKDAYS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

export const occupancyLegendText = inventory => {
  if (!inventory) return '';
  if (Number(inventory.total) === 1) {
    return 'Occupied vs available for this unit. Color reflects occupancy for the day.';
  }
  return `Booked units vs package inventory (total ${inventory.total}). Color reflects occupancy for the day.`;
};

export const occupancyTone = (booked, total) => {
  if (!total) return 'empty';
  const ratio = booked / total;
  if (ratio > 0.8) return 'high';
  if (ratio >= 0.4) return 'mid';
  return 'low';
};

const toYmd = value => {
  if (value == null || value === '') return null;
  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}/.test(value)) return value.slice(0, 10);
  return null;
};

/** True when calendar cell date is strictly before listing contractPeriod.start. */
export const isDateBeforeContractStart = (dateYmd, contractStart) => {
  const date = toYmd(dateYmd);
  const start = toYmd(contractStart);
  if (!date || !start) return false;
  return date < start;
};

export const buildMonthCells = (year, month, daysByDate) => {
  const start = moment({ year: year, month: month - 1, day: 1 });
  // Monday-first: moment().isoWeekday() is 1=Mon … 7=Sun
  const padStart = start.isoWeekday() - 1;
  const daysInMonth = start.daysInMonth();
  const cells = [];

  for (let i = 0; i < padStart; i += 1) {
    const d = start.clone().subtract(padStart - i, 'days');
    cells.push({ key: `pad-prev-${d.format('YYYY-MM-DD')}`, dayNum: d.date(), inMonth: false });
  }

  for (let day = 1; day <= daysInMonth; day += 1) {
    const date = start.clone().date(day).format('YYYY-MM-DD');
    const info = daysByDate[date] || { available: 0, total: 0, booked: 0 };
    cells.push({
      key: date,
      dayNum: day,
      inMonth: true,
      date: date,
      available: info.available,
      total: info.total,
      booked: info.booked,
      isToday: date === moment().format('YYYY-MM-DD'),
    });
  }

  while (cells.length % 7 !== 0) {
    const last = cells[cells.length - 1];
    const base = last.date ? moment(last.date) : start.clone().endOf('month');
    const d = base.clone().add(1, 'day');
    cells.push({
      key: `pad-next-${d.format('YYYY-MM-DD')}`,
      dayNum: d.date(),
      inMonth: false,
      date: d.format('YYYY-MM-DD'),
    });
  }

  return cells;
};
